import React from 'react';
import loadable from '@loadable/component';
import { Document, Font, Page, pdf, StyleSheet, Text, View } from '@react-pdf/renderer';
import moment from 'moment';
import isEmpty from 'ramda/src/isEmpty';
import Icon from '@components/@core/Icon';

const Header = loadable(() => import('@components/PdfHeader'), { ssr: false });

const styles = StyleSheet.create({
    container: {
        flexDirection: 'column',
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
        alignItems: 'stretch',
    },
    listHeader: {
        display: 'flex',
        flexDirection: 'row',
        margin: '10px',
        paddingBottom: '10px',
        paddingTop: '10px',
        borderBottomWidth: 0.25,
        borderBottomColor: 'black',
        borderBottomStyle: 'solid',
    },
    listItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        marginTop: '5px',
        marginRight: '10px',
        marginLeft: '10px',
        borderBottomWidth: 0.25,
        borderBottomColor: 'black',
        borderBottomStyle: 'solid',
        minHeight: '50px',
        maxHeight: '100px',
    },
    pageNumbers: {
        position: 'absolute',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        bottom: 10,
        left: 0,
        right: 0,
        textAlign: 'center',
        margin: '10px',
        fontSize: 10,
        fontFamily: 'Roboto',
        fontWeight: 'normal',
    },
});

Font.register({
    family: 'Roboto',
    fonts: [
        {
            src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
            fontWeight: 'normal',
        },
        {
            src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
            fontWeight: 'bold',
        },
        {
            src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
            fontWeight: 'light',
        },
    ],
});

export const CertificationPdf = (props) => {
    const { users, programs, date, tab } = props;
    const dateStart = moment(date.start).format('MMM DD');
    const dateEnd = moment(date.end).format('MMM DD');
    const pageTitle = tab === 'employees' ? 'Reports - Certifications - Employees' : 'Reports - Certifications - Certifications';

    pdf(
        <Document>
            <Page size="letter" style={styles.container} wrap>
                <Header style={{ paddingTop: 20 }} header={pageTitle} title="Certifications" date={`${dateStart} - ${dateEnd}`} fixed />
                {tab === 'employees' && (
                    <View wrap style={{ display: 'flex', paddingBottom: 20 }}>
                        <View fixed style={styles.listHeader}>
                            <View style={{ flex: 10.5 }}>
                                <Text style={{ fontSize: '10', fontWeight: 'normal', fontFamily: 'Roboto' }}>Employee</Text>
                            </View>
                            <View style={{ flex: 1.5 }}>
                                <Text style={{ fontSize: '10', fontWeight: 'normal', fontFamily: 'Roboto' }}>Open</Text>
                            </View>
                            <View style={{ flex: 9, padding: '0 10px' }}>
                                <Text style={{ fontSize: '10', fontWeight: 'normal', fontFamily: 'Roboto' }}>Certifications</Text>
                            </View>
                            <View style={{ flex: 3.5 }}>
                                <Text
                                    style={{
                                        fontSize: '10',
                                        fontWeight: 'normal',
                                        fontFamily: 'Roboto',
                                        textAlign: 'right',
                                    }}
                                >
                                    Completed
                                </Text>
                            </View>
                            <View style={{ flex: 9, padding: '0 10px' }}>
                                <Text style={{ fontSize: '10', fontWeight: 'normal', fontFamily: 'Roboto' }}>Certifications</Text>
                            </View>
                        </View>
                        {isEmpty(users) ? (
                            <View
                                styles={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '16px 0',
                                }}
                            >
                                <Text style={{ fontSize: '16', fontWeight: 'normal', fontFamily: 'Roboto' }}>No Careers Assigned</Text>
                            </View>
                        ) : (
                            users.map((user, index) => {
                                const name = user.profile.first_name + user.profile.last_name;
                                const openCerts = user.stats.open_certifications.map(({ title }) => title);
                                const completedCerts = user.stats.completed_certifications.map(({ title }) => title);
                                return (
                                    <View style={styles.listItem} key={`crd${index}`} wrap break={(index + 1) % 10 === 0}>
                                        <View style={{ flex: 10.5 }}>
                                            <Text style={{ fontSize: '12', fontWeight: 'light', fontFamily: 'Roboto' }}>{name}</Text>
                                        </View>
                                        <View style={{ flex: 1.5 }}>
                                            <Text
                                                style={{
                                                    fontSize: '12',
                                                    fontWeight: 'light',
                                                    fontFamily: 'Roboto',
                                                    textAlign: 'right',
                                                }}
                                            >
                                                {user.stats.open}
                                            </Text>
                                        </View>
                                        <View style={{ flex: 9, padding: '0 10px' }}>
                                            <Text style={{ fontSize: '12', fontWeight: 'light', fontFamily: 'Roboto' }}>{isEmpty(openCerts) ? 'Nothing open' : openCerts.join(', ')}</Text>
                                        </View>
                                        <View style={{ flex: 3.5 }}>
                                            <Text
                                                style={{
                                                    fontSize: '12',
                                                    fontWeight: 'light',
                                                    fontFamily: 'Roboto',
                                                    textAlign: 'right',
                                                }}
                                            >
                                                {user.stats.completed}
                                            </Text>
                                        </View>
                                        <View style={{ flex: 9, padding: '0 10px' }}>
                                            <Text style={{ fontSize: '12', fontWeight: 'light', fontFamily: 'Roboto' }}>
                                                {isEmpty(completedCerts) ? 'Nothing Completed' : completedCerts.join(', ')}
                                            </Text>
                                        </View>
                                    </View>
                                );
                            })
                        )}
                    </View>
                )}
                {tab === 'certifications' && (
                    <View wrap style={{ display: 'flex', paddingBottom: 20 }}>
                        <View fixed style={styles.listHeader}>
                            <View style={{ flex: 10.5 }}>
                                <Text style={{ fontSize: '10', fontWeight: 'normal', fontFamily: 'Roboto' }}>Certifications</Text>
                            </View>
                            <View style={{ flex: 1.5 }}>
                                <Text style={{ fontSize: '10', fontWeight: 'normal', fontFamily: 'Roboto' }}>Open</Text>
                            </View>
                            <View style={{ flex: 9, padding: '0 10px' }}>
                                <Text style={{ fontSize: '10', fontWeight: 'normal', fontFamily: 'Roboto' }}>Employees</Text>
                            </View>
                            <View style={{ flex: 3.5 }}>
                                <Text
                                    style={{
                                        fontSize: '10',
                                        fontWeight: 'normal',
                                        fontFamily: 'Roboto',
                                        textAlign: 'right',
                                    }}
                                >
                                    Completed
                                </Text>
                            </View>
                            <View style={{ flex: 9, padding: '0 10px' }}>
                                <Text style={{ fontSize: '10', fontWeight: 'normal', fontFamily: 'Roboto' }}>Employees</Text>
                            </View>
                        </View>
                        {isEmpty(programs) ? (
                            <View
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '16px 0',
                                }}
                            >
                                <Text style={{ fontSize: '16', fontWeight: 'normal', fontFamily: 'Roboto' }}>No Careers Assigned</Text>
                            </View>
                        ) : (
                            programs.map((program, index) => {
                                const openEmployees = program.stats.open_employees.map((e) => `${e.profile.first_name} ${e.profile.last_name}`);
                                const completedEmployees = program.stats.completed_employees.map((e) => `${e.profile.first_name} ${e.profile.last_name}`);

                                return (
                                    <View style={styles.listItem} key={`crd${index}`} wrap break={(index + 1) % 10 === 0}>
                                        <View style={{ flex: 10.5 }}>
                                            <Text style={{ fontSize: '12', fontWeight: 'light', fontFamily: 'Roboto' }}>{program.title}</Text>
                                        </View>
                                        <View style={{ flex: 1.5 }}>
                                            <Text
                                                style={{
                                                    fontSize: '12',
                                                    fontWeight: 'light',
                                                    fontFamily: 'Roboto',
                                                    textAlign: 'right',
                                                }}
                                            >
                                                {program.stats.open}
                                            </Text>
                                        </View>
                                        <View style={{ flex: 9, padding: '0 10px' }}>
                                            <Text style={{ fontSize: '12', fontWeight: 'light', fontFamily: 'Roboto' }}>{isEmpty(openEmployees) ? 'No employee' : openEmployees.join(', ')}</Text>
                                        </View>
                                        <View style={{ flex: 3.5 }}>
                                            <Text
                                                style={{
                                                    fontSize: '12',
                                                    fontWeight: 'light',
                                                    fontFamily: 'Roboto',
                                                    textAlign: 'right',
                                                }}
                                            >
                                                {program.stats.completed}
                                            </Text>
                                        </View>
                                        <View style={{ flex: 9, padding: '0 10px' }}>
                                            <Text style={{ fontSize: '12', fontWeight: 'light', fontFamily: 'Roboto' }}>
                                                {isEmpty(completedEmployees) ? 'No employee' : completedEmployees.join(', ')}
                                            </Text>
                                        </View>
                                    </View>
                                );
                            })
                        )}
                    </View>
                )}
                <Text fixed style={styles.pageNumbers} render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`} />
            </Page>
        </Document>
    )
        .toBlob()
        .then((e) => {
            const url = URL.createObjectURL(e);
            window.open(url, '__blank');
        });
};

const PdfIcon = ({ state, props }) => {
    const { activeTab, dateStart, dateEnd } = state;
    const { certificationsReport, jobRoles } = props;
    const { users, programs } = certificationsReport;
    const date = moment.range(dateStart, dateEnd);

    const handlePdf = () => {
        CertificationPdf({ users, programs, jobRoles, date, tab: activeTab });
    };
    return <Icon name="fas fa-print" color="#343f4b" size={16} onClick={handlePdf} />;
};

export default PdfIcon;
